module.exports = __webpack_public_path__ + "static/media/bitcoin.236cf4a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/bitcoin.svg
// module id = 848
// module chunks = 7